module.exports = __webpack_public_path__ + "img/test01-4.f23bdf2f.jpg";